import classNames from 'classnames';
import React from 'react';
import clearIcon from '../../icons/non-prefilled/16x16/clear.svg';
import SVGIcon from '../SVGIcon';
import { useIsFieldSetDisabled } from './FieldSet';
import * as styles from './ToggleControl.module.scss';

export interface ToggleControlProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  type: 'checkbox';
  error?: string;
  label?: React.ReactNode;
  disabled?: boolean;
  config?: {
    knobSize: number;
    trackWidth: number;
  };
}

const ToggleControl = ({
  error,
  label,
  disabled,
  config,
  ...inputProps
}: ToggleControlProps) => {
  const isFieldSetDisabled = useIsFieldSetDisabled();
  const isDisabled = disabled || isFieldSetDisabled;

  return (
    <label
      className={classNames(styles.toggle, { [styles.error]: error })}
      style={
        config
          ? ({
              '--toggle-knob-size': `${config?.knobSize}px`,
              '--toggle-track-width': `${config?.trackWidth}px`,
            } as React.CSSProperties)
          : undefined
      }
    >
      {!!label && <div className={styles.label}>{label}</div>}
      <input className={styles.input} disabled={isDisabled} {...inputProps} />
      <div
        className={classNames(styles.track, { [styles.disabled]: isDisabled })}
      >
        <div className={styles.knob}>
          {isDisabled && <SVGIcon size={10}>{clearIcon}</SVGIcon>}
        </div>
      </div>
    </label>
  );
};

export default ToggleControl;
